import { RequestMainService } from "../request";

/** API màn "Lỗi phát" (A6) — backend: models/admin/app-log. */
export class AppLogService {
  static summary(date: string) {
    return RequestMainService.get(`/admin/app-logs/summary`, { date }).then(({ result }) => result);
  }

  static devices(params: { date: string; searchString?: string; category?: string; page?: number; pageSize?: number }) {
    return RequestMainService.get(`/admin/app-logs/devices`, params).then(({ result }) => result);
  }

  static logs(params: { mac: string; date: string; category?: string; page?: number; pageSize?: number }) {
    return RequestMainService.get(`/admin/app-logs`, params).then(({ result }) => result);
  }

  static export(mac: string, date: string) {
    return RequestMainService.get(`/admin/app-logs/export`, { mac, date }).then(({ result }) => result);
  }
}
